import React from "react";
import { useAnalytics } from "../../hooks/useAnalytics";
import { useKlaviyo } from "../../hooks/useKlaviyo";

import { useSocialShare } from "../../hooks/useSocialShare";

export const withShare =
  (Component) =>
  ({ name = "Share", link, wishlist, image, ...props }) => {
    const { socialShare } = useSocialShare();
    const { track } = useKlaviyo();
    const { trackShare } = useAnalytics();

    const handleShare = (type, image) => {
      socialShare(type, link, image, wishlist);
      if (!wishlist) {
        trackShare(type, "Article", link);
        track("Blog Share", { link, image: image?.asset?.url || image });
      }
    };

    Component.displayName = name;
    return <Component {...props} image={image} handleShare={handleShare} />;
  };
